{
	"type": "line",
	"minzoom": 8,
	"layout": {},
	"paint": {
		"line-color": ["match", ["get", "sym_code"], "DM", "#f00", "#333"],
		"line-width": ["match", ["get", "sym_code"], "DM", 2, 0.4]
	}
}
